module.exports = __webpack_public_path__ + "img/Graph4_30days_green.c6112fad.png";